























import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { heightDistribute } from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import Pie from '../../_components/charts/Pie.vue'
import BarDifference from '../../_components/charts/BarDifference.vue'

@Component({
  components: {
    BasePanel,
    Pie,
    BarDifference
  }
})
export default class extends Vue {
  @Prop({}) private data!: any
  private pieData: any = {}
  private barDataArray: Array < object > = []
  private itemList: any = [
    {
      name: '很矮 占比＜10%',
      color: '#F87A52'
    }, {
      name: '较矮 10%≤占比<25%',
      color: '#FFA100'
    }, {
      name: '一般 25%≤占比≤75%',
      color: '#6DD400'
    },
    {
      name: '较高 75%<占比≤90%',
      color: '#3A91FF'
    }, {
      name: '很高 占比>90%',
      color: '#A35DFF'
    }
  ]
  private colorList: any = []

  created() {
    if (!this.$route.query.searchParams) return
    let params = JSON.parse(this.$route.query.searchParams as string)
    heightDistribute(params).then(res => {
      this.pieData = res.data.heightDistribute
      this.barDataArray = res.data.barChart || []
    })
    this.itemList.map((v:any) => {
      this.colorList.push(v.color)
    })
    // let obj: any = this.data.pie
    // obj.HeightLastTypeIntro = obj.title
    // obj.data = []
    // this.data.pie.dataList.map(v => {
    //   obj.data.push({ name: v.name, value: v.value * 100 })
    // })
    // this.list.push(obj)
    // this.data.staminaHeightPercentVoLine.map(v => {
    //   this.list.push(v)
    // })
  }
}
